import React from 'react';

const LightingSwitch = ({ viewGLRef }) => {
  const handleLightingChange = (type) => {
    if (viewGLRef.current) {
      viewGLRef.current.lighting.updateSceneLighting(type, viewGLRef.modelsLoader.modelsCenter);
    }
  };

  return (
    <div className={"lightingSwitch"}>
      <label>
        <input
          type="radio"
          name="lightingType"
          value="addLightV9"
          onChange={e => handleLightingChange(e.target.value)}
        />
        old lighting
      </label>
      <label>
        <input
          type="radio"
          name="lightingType"
          value="addLightV10"
          defaultChecked
          onChange={e => handleLightingChange(e.target.value)}
        />
        new lighting
      </label>
      {/*<label>*/}
      {/*  <input*/}
      {/*    type="radio"*/}
      {/*    name="lightingType"*/}
      {/*    value="addLightV6"*/}
      {/*    onChange={e => handleLightingChange(e.target.value)}*/}
      {/*  />*/}
      {/*  3*/}
      {/*</label>*/}
      {/*<label>*/}
      {/*  <input*/}
      {/*    type="radio"*/}
      {/*    name="lightingType"*/}
      {/*    value="addLightV7"*/}
      {/*    onChange={e => handleLightingChange(e.target.value)}*/}
      {/*  />*/}
      {/*  4*/}
      {/*</label>*/}
      {/* Добавьте дополнительные радиокнопки для новых методов освещения здесь */}
    </div>
  );
};

export default LightingSwitch;
